import { IActionType, IMiddlewareNext, IMiddlewareStore } from '../common/common.types'
import { getCurrentTimeFormatted } from '../utilities/dateTime.util'

export const reducerLoggerMiddleware = <T extends IActionType>(store: IMiddlewareStore) => (next: IMiddlewareNext<T>) => (action: T): void => {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_REDUX_LOGGER === 'true') {
    console.group(`%cAction: %c${action.type} %cat ${getCurrentTimeFormatted()}`, 'color: lightgreen; font-weight: bold', 'color: blue; font-weight: bold', 'color: lightblue; font-weight: lighter')
    console.log('%cPrevious State:', 'color: #9E9E9E; font-weight: 700', store.getState())
    console.log('%cAction:', 'color: #00A7F7; font-weight: 700', action)
    next(action)
    console.log('%cNext State:', 'color: #47B04B; font-weight: 700', store.getState())
    console.groupEnd()
  } else {
    next(action)
  }
}
